import Form from "./form";
import IRepo from "../../../common/interfaces/repo";
import Repo from "../../../common/state/modules/repo";
import TrackedModel from "../../../common/models/tracked/trackedModel";

export default class CustomStatus extends TrackedModel{

  form: Form;
  name: string;
  sort_order: number;
  reference_id: number;

  static repo: IRepo<CustomStatus> = new Repo<CustomStatus>('custom_statuses', CustomStatus);

  constructor() {
    super();
    this.defineProperty('name', null);
    this.defineProperty('sort_order', null);
    this.defineProperty('reference_id', null);
  }

  static get placeholderName() {
    return "Enter Status Name"
  }

  static findByReferenceOrClientId(form, id): CustomStatus{
    let status = null;
    const isReferenceId = id.toString().length === 1

    if (isReferenceId) {
      Object.keys(form.custom_statuses).some (k => {
        if (form.custom_statuses[k].reference_id === parseInt(id, 10)) {
          status = form.custom_statuses[k]
          return true
        }
      });
    } else {
      status = form.custom_statuses[id]
    }
    
    return status;
  }

  get rootName() {
    return 'custom_statuses';
  }

  get vOption() {
    return {
      sortOrder: this.sort_order,
      label: this.name,
      value: this.clientIdOrReferenceId
    }
  }

  get clientIdOrReferenceId() {
    return this.client_id || this.reference_id;
  }
}